import React from 'react';

const TrendingSection = ({ articles, onArticleClick, truncateText, formatDate, onCardClick }) => {
  const handleClick = async (article) => {
    if (onCardClick) {
      await onCardClick(article.id);
    }
    onArticleClick(article);
  };

  return (
    <aside className="trending-column">
      <h2>Trending Summaries</h2>
      <div className="trending-list">
        {articles.map((article, i) => (
          <div 
            key={i} 
            className="trending-item" 
            onClick={() => handleClick(article)}
          >
            <div className="trending-number">{i + 1}</div>
            <div className="trending-content">
              <h4>
                {truncateText(article.title, 65)}
              </h4>
              <div className="trending-meta">
                <span>{article.source_name}</span>
                <span> · </span>
                <span>{formatDate(article.scraped_at)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default TrendingSection;